import { LINFOX_CURRENT_TAB } from '../actionTypes';

export const setCurrentTab = (tabIndex: number) => ({
  type: LINFOX_CURRENT_TAB,
  data: tabIndex
});
